import * as React from "react";

import { ShowSnackbar } from "@webapp/store/ui/action-creators";
import { Action } from "redux";
import { Translate } from "react-localize-redux";
import { RemoveAssetUpload, UpdateAssetUpload } from "../action-creators";

export default function getAssetActions(id: string, error?: string) {
  const actions: Action[] = [
    new UpdateAssetUpload<"error">(
      id,
      "error",
      error || "Unknown Error"
    ) as Action,
    new RemoveAssetUpload([id]),
  ];
  if (error !== "ASSET.UPLOAD_CANCELED") {
    actions.push(
      new ShowSnackbar("TRACK", {
        title: <Translate id="ASSET.UPLOAD_ERROR" />,
        text: `There was an error when uploading the file.`,
        hideDismiss: false,
      }),
      new RemoveAssetUpload([id])
    );
  }
  return actions;
}
